import React from 'react';
import { motion } from 'framer-motion';
export function Mechanism() {
  return <section className="py-24 px-6 bg-dark relative overflow-hidden" data-id="element-89">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[500px] bg-radial-gold opacity-20 pointer-events-none" data-id="element-90"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-92">
          <h2 className="font-serif text-3xl md:text-4xl text-cream mb-10" data-id="element-93">
            La Solución:{' '}
            <span className="text-gold italic" data-id="element-94">El Espejo Inverso</span>
          </h2>

          <div className="space-y-6 font-sans text-lg text-cream/90 font-light leading-relaxed text-left md:text-center" data-id="element-95">
            <p data-id="element-96">
              La solución no es "actuar" como alguien más, sino activar el{' '}
              <strong className="text-gold font-medium" data-id="element-97">Espejo Inverso</strong>.
              Esta técnica de psicología evolutiva te permite soltar la tensión
              del control y adoptar el{' '}
              <strong className="text-gold font-medium" data-id="element-98">
                "Estatus Relajado"
              </strong>
              .
            </p>
            <p data-id="element-99">
              Al ajustar micro-señales específicas en tu cuello, manos y mirada,
              dejas de competir y empiezas a atraer.
            </p>
            <p className="text-xl font-serif italic text-gold mt-8" data-id="element-100">
              "El Espejo Inverso crea un vacío de polaridad que obliga al hombre
              de alto valor a dar el primer paso para protegerte y reclamar tu
              atención."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}